const styleSheet = () => ({
  container: {
    position: 'fixed',
    zIndex: 100000,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '30px',
  },
  card: {
    position: 'relative',
    opacity: 0,
    overflow: 'auto',
    borderRadius: '8px',
    backgroundColor: '#F8F9FB',
    boxShadow: '0 4px 20px 0 rgba(0,0,0,0.4)',
    '& h2': {
      color: '#051D39',
      fontSize: (props: any) =>
        (props.overrideStyles && props.overrideStyles.h2FontSize) || '24px',
      lineHeight: '30px',
      display: 'block',
      textAlign: (props: any) => props.titlePosition,
      marginBottom: (props: any) =>
        (props.overrideStyles && props.overrideStyles.h2MarginBottom) || '32px',
    },
    maxHeight: '100vh',
    boxSizing: 'border-box',
    padding: (props: any) =>
      (props.overrideStyles && props.overrideStyles.cardWrapperPadding) ||
      '20px 10px',
    width: (props: any) => props.width || 'auto',
    height: (props: any) => props.height || 'auto',
  },
  scroll: {
    padding: (props: any) =>
      (props.overrideStyles && props.overrideStyles.scrollPadding) ||
      '12px 63px',
    overflow: 'auto',
    height: '100%',
  },
});

export default styleSheet;
